import * as React from 'react';
import { useRef } from 'react'
import 'react-multi-carousel/lib/styles.css';
import { useEffect, useState } from "react";
import { Box, Card } from '@mui/material';
import { redirect } from 'react-router-dom';

interface Props {
    dataPoints: Array<any>;
    ubication: string;
    height: string;
    width: string;
    zoom: number;
}


export default function MapDetail(props: Props) {

  const icons: Record<any, { icon: string, width: number }> = {
    club: {
      icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/club.svg',
      width: 50,
    },
    hotel: {
      icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/hotelcama.svg',
      width: 50,
    },
    comercio: {
      icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/proshop.svg',
      width: 50,
    },
    restaurant: {
      icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/restaurant.svg',
      width: 50,
    },
    otros: {
        icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/club.svg',
        width: 50,
      },
  };



  let [mapa, setMap] = useState<google.maps.Map>()
  const ref = useRef<HTMLDivElement>()
  const placeInput = document.getElementById("place-input") as HTMLInputElement
  let autocomplete:any;
  

//   function widthScreen () {
//       const widthScreen = document.body.clientWidth
//       if (widthScreen < 500) { let widthMap = "300px"
//          return widthMap
//       } else {
//         let widthMap = "800px"
//         return widthMap
//       }
//     }
  
//     function heightScreen () {
//       const widthScreen = document.body.clientWidth
//       if (widthScreen < 500) { let heightMap = "500px"
//          return heightMap
//       } else {
//         let heightMap = "700px"
//         return heightMap
//       }
//     }

  let positionLatCenter = Number.parseFloat(props.ubication.slice(0,props.ubication.indexOf(",")))
  let positionLngCenter = Number.parseFloat(props.ubication.slice(((props.ubication.indexOf(","))+1),props.ubication.length))
  const myLatLngCenter = { lat: positionLatCenter, lng: positionLngCenter };


  const Map = async () => {

    useEffect(()=>{
      if(ref.current && !mapa){
        setMap(new google.maps.Map(document.getElementById('map') as HTMLElement, {
          center: myLatLngCenter,
          zoom: props.zoom,
          mapId: 'b43fd4b4ec044b83 ',
          mapTypeId: google.maps.MapTypeId.HYBRID
        }))
      }
    }, [mapa])

    const marcadores = props.dataPoints

    const {AdvancedMarkerElement}  = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    const markers = marcadores.map((position, i) => {
      let markerSvg = document.createElement('img');
      markerSvg.src = icons[marcadores[i].typeMarker].icon
      markerSvg.width = 70;

      let positionLat = Number.parseFloat(marcadores[i].coordinates.slice(0,marcadores[i].coordinates.indexOf(",")))
      let positionLng = Number.parseFloat(marcadores[i].coordinates.slice(((marcadores[i].coordinates.indexOf(","))+1),marcadores[i].coordinates.length))
      const myLatLng = { lat: positionLat, lng: positionLng };


      let collisionBehavior = google.maps.CollisionBehavior.REQUIRED;  // Si se superponen no desaparecen


      const marker = new google.maps.marker.AdvancedMarkerElement({
        map: mapa,
        position: myLatLng,
        title: marcadores[i].pointId,
        content: markerSvg,
        collisionBehavior: collisionBehavior,
      });

      if (mapa) {
        mapa.addListener('zoom_changed', () => {
          const zoom = mapa.getZoom();
          if (zoom) {
              // Only show each marker above a certain zoom level.
              marker.map = zoom > 8 ? mapa : null;
          }
        });
      }

      marker.addListener("click", () => {
        let infowindow = new google.maps.InfoWindow({content: `<div class="infowindow"><a href="/categoria/${marcadores[i].typeMarker}/${marcadores[i].pointId}" target="_blank"><b>${marcadores[i].name}</b></a>, ${marcadores[i].address}</div><br/><div class="infowindow">${marcadores[i].country}, ${marcadores[i].state}, ${marcadores[i].locate}</div> <div class="infowindow"><a href="https://maps.google.com/maps?ll=${positionLat},${positionLng}&z=15" target="_blank">Ver en Google Maps</a></div>`,ariaLabel: marcadores[i].name, disableAutoPan: true,})
        infowindow.open({
          anchor: marker,
          map: mapa,
        });        
      });
      return marker;
    });

  };


  const searchGoogleMap = () => {

    autocomplete = new google.maps.places.Autocomplete(placeInput);
    autocomplete.addListener("place_changed",() => {
      const place = autocomplete.getPlace();

      try { 
        mapa.setCenter(place.geometry.location)
      } catch (e) {
        return
      }
      
      mapa.setZoom(13);
    })
  }

  Map();
  searchGoogleMap();
  
  return (
    <>
      <Box sx={{ width:"100%", display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
        <Box  sx={{ width:{xs:"80%", sm:"50%", md:"50%"}, display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
          <Box>
            <Card sx={{transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
                <Box id="map" ref={ref as any} style={{ width: props.width, minHeight:props.height}}></Box>
            </Card>
          </Box>
        </Box>
      </Box>
    </>
    )
}